export var SrciScreenEnumsObj = {
    CARD_LIST_SCREEN: "CARD_LIST_SCREEN",
    NEW_USER_SCREEN: "NEW_USER_SCREEN",
    OTP_SCREEN: "OTP_SCREEN",
    OTP_CHANNEL: "OTP_CHANNEL",
    LOGIN_SCREEN: "LOGIN_SCREEN",
    ADD_CARD_SCREEN: "ADD_CARD_SCREEN",
};
